export const PENDING_PUSH_NAVIGATION_KEY = "vaultquest:pendingPushNavigation";

export function normalizePendingPushNavigation(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;

  const type = String(value.type || "").trim();
  const route = String(value.route || "").trim();
  const tournamentId = String(value.tournamentId || "").trim();
  const dateKey = String(value.dateKey || "").trim();

  const validSpecialCup =
    type === "special_cup_three_day" &&
    /^\d{4}-\d{2}-\d{2}_special$/.test(tournamentId) &&
    /^\d{4}-\d{2}-\d{2}$/.test(dateKey) &&
    tournamentId === `${dateKey}_special`;
  const validTournamentReminder =
    type === "tournament_one_hour_reminder" &&
    tournamentId.length > 0 &&
    (!dateKey || /^\d{4}-\d{2}-\d{2}$/.test(dateKey));

  if (route !== "tournament" || (!validSpecialCup && !validTournamentReminder)) {
    return null;
  }

  return { type, route, tournamentId, dateKey };
}

export function consumePendingPushNavigation(storage) {
  if (!storage || typeof storage.getItem !== "function") return null;
  const raw = storage.getItem(PENDING_PUSH_NAVIGATION_KEY);
  if (!raw) return null;

  storage.removeItem(PENDING_PUSH_NAVIGATION_KEY);
  try {
    return normalizePendingPushNavigation(JSON.parse(raw));
  } catch {
    return null;
  }
}
